<template>
	<div class="col-lg-6">
		<div :class="{'block': layout === 'v1'}">
			<div :class="{'block-header block-header-default': layout === 'v1'}">
				<h3 :class="{'block-title': layout === 'v1', 'mb-2': layout === 'v2'}">Success Manager</h3>
			</div>
				<div class="block-content pb-4" style="min-height: 116px;" v-for="manager in managers" :key="manager.id">
					<div>{{ manager.name }}</div>
					<a :href="`mailto:${manager.email}`" target="_blank">{{ manager.email }}</a>
				</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			managers: {
				type: Array,
				default:[],
			},
			layout: {
				type: String,
				default: 'v1',
			}
		}
	};
</script>